export default __webpack_public_path__ + "static/media/offline2.98ca6ca5.png";